import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CommonHeader from '@/components/CommonHeader.vue';
import BlankLayout from '@/layouts/BlankLayout.vue';
import AjaxButton from '@/components/AjaxButton.vue';
import BeeCheckbox from '@/components/BeeCheckbox.vue';
import Modal from '@/components/Modal.vue';
import Map from '@/components/Map.vue';
import firebase from 'firebase';
import AddressService from '@/services/AddressService';
import { TypeAddressBook, Location as Loc } from '@/models/AddressBook';
import { parseAddress } from '@/utils/MapsUtils';
import { updateUser } from '@/services/UserService';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
let Location = class Location extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.modal = false;
        this.firstRegister = false;
        this.location = new firebase.firestore.GeoPoint(Number(this.lat), Number(this.lng));
        this.order = this.$store.state.order;
        this.user = this.$store.state.user;
        this.reference = '';
        this.name = '';
        this.email = '';
        this.phone = '';
        this.loc = {
            lat: 0,
            lng: 0
        };
        this.address = {
            defaultAddress: false,
            location: this.loc,
            formatAddress: '',
            country: '',
            locality: '',
            state: '',
            street: '',
            postal: '',
            references: '',
            type: TypeAddressBook.HOME,
            otherDescription: ''
        };
        this.formErrors = {
            name: false,
            email: false,
            phone: false,
            address: false,
            references: false
        };
    }
    cancel() {
        this.modal = false;
    }
    async deleteAddress() {
        if (this.idAddress != '') {
            await AddressService.deleteAddress(this.idAddress);
        }
        this.$router.push('/locations');
    }
    loadInfo(value) {
        this.loc = new Loc(value.lat, value.lng);
        this.address.location = this.loc;
    }
    async loadInfoData(value) {
        const data = value[0];
        this.address.formatAddress = data.formatted_address;
        this.address.country = await parseAddress(data, 'country');
        this.address.locality = await parseAddress(data, 'locality');
        this.address.state = await parseAddress(data, 'state');
        this.address.street = await parseAddress(data, 'street');
        this.address.postal = await parseAddress(data, 'postal');
    }
    async confirm() {
        this.loading = true;
        if (!this.validForm())
            return;
        await this.updateData();
        if (this.idAddress != '') {
            await AddressService.updateAddressBook(this.idAddress, this.address);
        }
        else {
            if (this.firstRegister)
                this.address.defaultAddress = true;
            await AddressService.saveAddressBook(this.address);
        }
        this.loading = false;
        this.$router.push('/summary');
    }
    formDelete() {
        this.modal = true;
    }
    async updateData() {
        if (!this.validForm())
            return;
        const update = await updateUser(this.user, this.name, this.email, this.phone, this.user.authToken);
        if (update) {
            await this.$store.dispatch('login', update);
        }
    }
    validForm() {
        this.formErrors = { name: false, email: false, phone: false, address: false, references: false };
        if (!this.name)
            this.formErrors.name = true;
        if (!this.email)
            this.formErrors.email = true;
        if (!this.address.formatAddress)
            this.formErrors.address = true;
        if (!this.address.references)
            this.formErrors.references = true;
        if (this.checkDigitRepeated(this.phone, 5) && this.phone.length !== 10)
            this.formErrors.phone = true;
        for (const error of Object.values(this.formErrors)) {
            if (error == true) {
                this.loading = false;
                return false;
            }
        }
        return true;
    }
    checkDigitRepeated(input, repeat) {
        const regex = new RegExp('(\\d)\\1{' + repeat + '}', 'g');
        return !!input.match(regex);
    }
    async created() {
        if (this.user) {
            this.name = this.user.name;
            this.email = this.user.email;
            this.phone = this.user.phone;
        }
        if (this.idAddress != '') {
            const request = await AddressService.getAddressBookById(this.idAddress);
            if (request) {
                this.address = request.data;
                this.location = this.newLocation;
            }
        }
        if (this.length == '0') {
            this.firstRegister = true;
        }
    }
    get newLocation() {
        return this.location;
    }
};
__decorate([
    Prop({ default: '' })
], Location.prototype, "idAddress", void 0);
__decorate([
    Prop({ default: '' })
], Location.prototype, "lat", void 0);
__decorate([
    Prop({ default: '' })
], Location.prototype, "lng", void 0);
__decorate([
    Prop({ default: '' })
], Location.prototype, "length", void 0);
Location = __decorate([
    Component({
        components: {
            BlankLayout,
            CommonHeader,
            AjaxButton,
            BeeCheckbox,
            Modal,
            Map,
            SpinnerHolder
        }
    })
], Location);
export default Location;
